<template>
  <div style="">
  <div id="city-top">
    <div class="city-contain">
      <img src="../assets/images/city_top.jpg">
    </div>
  </div>
  <div id="city-content">
    <div class="city-contain">
      <div class="top-link">
        <a href="/index" class="btn">进入优卡思家教</a>
      </div>
      <div class="city-list">
          <dl class="first">
            <dt>热门城市</dt>
            <dd v-for="(item, index) in hotCity">
              <span @click="toIndexPage(item)">{{item.name}}</span></dd>
          </dl>
        <div v-for="(item, index) in proAreaList">
          <div class="area"><span>{{item.name}}</span></div>
          <dl v-for="(item_1, index_2) in item.children">
            <dt>{{item_1.name}}</dt>
            <dd v-for="(item_2, index_2) in item_1.children">
              <span @click="toIndexPage(item_2)">{{item_2.name}}</span>
            </dd>
          </dl>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
  <div id="city-footer">
    <div class="city-contain" style="display: inline-block;">
      <p>© 2018－2021优卡思教育 | 沪ICP备19007188号</p>
    </div>
  </div>
  </div>
</template>

<script type="es6">
  import $ from 'jquery'
  import {cityList, clickAdd, moreCity, provincesArea,} from "../config/axioUtil";

  export default {
        name: "moreCity",
      data(){
          return {
            proAreaList: [],
            hotCity:[],
          }
      },
      created() {
      },
      mounted() {
        this.getmoreCity()
        this.getHotCity()
      },
      methods: {
        getmoreCity(){
            provincesArea().then(data=>{
              this.proAreaList = data.data
              for (let i in this.proAreaList){
                moreCity({'proArea': this.proAreaList[i].id}).then(datat=>{
                  this.proAreaList[i]['children'] = datat.data
                  this.$set(this.proAreaList[i])
                }).catch(err=>{
                  console.log(err)
                })
              }

            }).catch(err=>{
              console.log(err)
            })
            // moreCity().then(data=>{
            //   console.log(data)
            //   this.proAreaList = data.data
            // }).catch(err=>{
            //   console.log(err)
            // })
          },
        getHotCity(){
            cityList({'hot': 1}).then(data=>{
              this.hotCity = data.data
            }).catch(err=>{
              console.log(err)
            })
        },
        toIndexPage(item){
          let params = new FormData()
          params.append('id', item.id)
          params.append('type', 'city')
          clickAdd(params).then().catch(err=>{
            console.log(err)})
          localStorage.setItem('currentCity', JSON.stringify(item))
          this.$store.dispatch('setInfo')
          this.$router.push({name: 'index'})
          $('body,html').animate({scrollTop: 0}, 200);
        }
      }
    }
</script>

<style scoped>
  @import "../assets/css/modules/moreCity.css";
</style>



// WEBPACK FOOTER //
// src/views/moreCity.vue